import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createProductsPresentations, editProductsPresentations, SeeProductsPresentations } from '../../../../actions/productActions'
import PresentationsView from '../../../../containers/Inventory/Products/Presentations/Presentations'
const Presentations = () => {
  const {presentations} = useSelector(state=>state.productsList)
  const [isEdit, setIsEdit] = useState(null)
  const dispatch = useDispatch()
  useEffect(() => {
    
  dispatch(SeeProductsPresentations())
    return () => {
      
    }
  }, [])
  const formik = useFormik({
    initialValues:{
      name:""
    },
    onSubmit:(values)=>{
      if(isEdit){
        dispatch(editProductsPresentations(values.name,values.id,()=>formik.resetForm()))
      }else{
        dispatch(createProductsPresentations(values.name,()=>formik.resetForm()))
      }

    }
  })
  const create = (name,clear)=>{
    dispatch(createProductsPresentations(name,clear))
  }
  const edit = (name,id,clear)=>{
    dispatch(editProductsPresentations(name,id,clear))
  }
  
  return (
    <PresentationsView presentations={presentations} formik={formik} create={create} edit={edit} isEdit={isEdit} setIsEdit={setIsEdit}/>
  )
}

export default Presentations